/* ===================================================================
   kuoca-pdp.js — design-bridge apply(pdp)
   출처: preview/pdp.html 스크립트 (갤러리 레일·mo 캐러셀 dot·수량 스테퍼·아코디언 260ms).
   헤더 상태머신·모달·스크롤 잠금은 kuoca-main.js(전역) 소관.
   실상품: 스테퍼가 폼 hidden [name=quantity] 를 동기화, ADD TO CART 는
   테마 <product-form>(product-form.js) 이 AJAX 담기 + 카트 드로어 오픈.
   =================================================================== */
(function () {
  'use strict';

  /* 갤러리: 썸네일 레일 (pc/ta) */
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.kuoca-pdp-gallery__thumb'));

  function activateThumb(thumb, behavior) {
    if (!thumb) return;
    thumbs.forEach(function (x) {
      x.classList.remove('is-active');
      x.setAttribute('aria-selected', 'false');
    });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-selected', 'true');
    var fig = document.getElementById(thumb.getAttribute('data-target'));
    if (fig) fig.scrollIntoView({ behavior: behavior || 'smooth', block: 'start' });
  }

  /* 썸네일 클릭이 만든 smooth 스크롤 구간 — 그 동안은 스크롤→썸네일 역동기를 멈춘다.
     (중간 프레임마다 다른 썸네일이 켜졌다 꺼지는 깜빡임 차단) */
  var suppressSyncUntil = 0;

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      suppressSyncUntil = Date.now() + 900;
      activateThumb(t);
    });
  });

  /* 갤러리(pc/ta): 페이지 스크롤로 지금 보고 있는 이미지에 맞춰 썸네일 활성 상태를 되돌려 맞춘다 (QA).
     위쪽 클릭 핸들러가 썸네일→스크롤이라면, 여기는 그 역방향만 담당한다.
     기준선은 헤더 하단(= 썸네일 레일이 sticky 로 붙는 지점). 그 선을 덮고 있는 figure 가
     "지금 보는 이미지"다. variant 선택 시 figure 를 order 로 재배치하므로 DOM 순서를 믿지 않고
     실제 rect 상단으로 정렬해 판정한다. */
  var galleryScroll = document.querySelector('.kuoca-pdp-gallery__scroll');
  if (thumbs.length && galleryScroll) {
    var thumbByTarget = {};
    thumbs.forEach(function (t) {
      var id = t.getAttribute('data-target');
      if (id) thumbByTarget[id] = t;
    });

    var syncQueued = false;

    function headerLine() {
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h'));
      return (isNaN(h) ? 84 : h) + 1;
    }

    function syncThumbToScroll() {
      syncQueued = false;
      if (Date.now() < suppressSyncUntil) return;
      /* mo 는 .kuoca-pdp-gallery 자체가 display:none — 레이아웃이 없으면 판정하지 않는다. */
      if (!galleryScroll.offsetParent) return;

      var line = headerLine();
      var rows = Array.prototype.slice
        .call(galleryScroll.querySelectorAll('.kuoca-pdp-gallery__figure'))
        .map(function (fig) {
          return { fig: fig, top: fig.getBoundingClientRect().top };
        })
        .sort(function (a, b) {
          return a.top - b.top;
        });
      if (!rows.length) return;

      /* 기준선을 지난 마지막 이미지 — 갤러리 위쪽에 있을 때는 첫 이미지로 고정된다. */
      var current = rows[0].fig;
      rows.forEach(function (r) {
        if (r.top <= line) current = r.fig;
      });

      var active = thumbByTarget[current.id];
      if (!active || active.classList.contains('is-active')) return;
      thumbs.forEach(function (x) {
        var on = x === active;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-selected', String(on));
      });
    }

    function queueSync() {
      if (syncQueued) return;
      syncQueued = true;
      requestAnimationFrame(syncThumbToScroll);
    }

    window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);
    queueSync();
  }

  /* 이형 상품(variant)에 이미지가 연결돼 있으면 옵션을 바꿀 때 그 이미지를 갤러리 맨 앞으로
     끌어온다. pc 갤러리는 이미지를 세로로 전부 나열하고 페이지 스크롤로 보는 구조라
     스크롤로 맞추면 화면이 튄다 — 세 컨테이너 모두 flex 이므로 order 로 재배치한다.
     서버(Liquid)도 진입 시 같은 규칙으로 렌더한다. 연결된 media 가 갤러리에 없으면
     (6 장 제한 밖 등) 아무 것도 하지 않는다. */
  function galleryItems() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-media-id]'));
  }

  function showMedia(mediaId) {
    if (!mediaId) return;
    var items = galleryItems();
    var found = items.some(function (el) {
      return el.getAttribute('data-media-id') === mediaId;
    });
    if (!found) return;

    items.forEach(function (el) {
      el.style.order = el.getAttribute('data-media-id') === mediaId ? '-1' : '';
    });

    thumbs.forEach(function (t) {
      var on = t.getAttribute('data-media-id') === mediaId;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
    });

    /* mo 캐러셀은 맨 앞으로 되돌린다 — 선택 이미지가 첫 슬라이드가 됐으므로. */
    var moTrack = document.getElementById('kuocaPdpTrack');
    if (moTrack) moTrack.scrollTo({ left: 0, behavior: 'auto' });
  }

  /* 갤러리: mo 캐러셀 분할형 인디케이터 바 */
  var track = document.getElementById('kuocaPdpTrack');
  var dots = Array.prototype.slice.call(document.querySelectorAll('#kuocaPdpDots i'));
  if (track && dots.length) {
    track.addEventListener(
      'scroll',
      function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === i);
        });
      },
      { passive: true },
    );
  }

  function formatPdpMoney(amount, fallback) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(amount, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '');
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'ko-KR', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'KRW',
      }).format(amount / 100);
    } catch (error) {
      return fallback;
    }
  }

  function updateProductPricing(detail) {
    if (!detail) return;

    var priceBlock = detail.querySelector('[data-kuoca-pdp-price]');
    if (!priceBlock) return;

    var unitPriceAmount = parseInt(priceBlock.getAttribute('data-kuoca-pdp-unit-price-amount'), 10);
    if (Number.isNaN(unitPriceAmount)) return;

    var qtyInput = detail.querySelector('#kuocaQtyInput');
    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var currentPrice = priceBlock.querySelector('[data-kuoca-pdp-current-price]');
    var comparePrice = priceBlock.querySelector('[data-kuoca-pdp-compare-price]');
    var unitComparePriceAmount = parseInt(priceBlock.getAttribute('data-kuoca-pdp-unit-compare-price-amount'), 10);
    var onSale = priceBlock.getAttribute('data-kuoca-pdp-on-sale') === 'true';
    var available = priceBlock.getAttribute('data-kuoca-pdp-variant-available') === 'true';
    var fallbackPrice = currentPrice ? currentPrice.textContent : '';

    if (currentPrice) currentPrice.textContent = formatPdpMoney(unitPriceAmount, fallbackPrice);
    if (comparePrice) {
      comparePrice.textContent =
        onSale && !Number.isNaN(unitComparePriceAmount)
          ? formatPdpMoney(unitComparePriceAmount, comparePrice.textContent)
          : '';
      comparePrice.hidden = !onSale;
    }

    /* 품절: 가격에 취소선 + 옆에 SOLD OUT (서버 렌더와 같은 클래스·hidden 을 유지) */
    var soldOutLabel = priceBlock.querySelector('[data-kuoca-pdp-soldout]');
    priceBlock.classList.toggle('kuoca-pdp-detail__price--soldout', !available);
    if (soldOutLabel) soldOutLabel.hidden = available;

    var form = detail.querySelector('form');
    var addButton = form && form.querySelector('.kuoca-pdp-addcart');
    var addLabel = addButton && addButton.querySelector('[data-kuoca-pdp-addcart-label]');
    if (addButton) addButton.disabled = !available;
    if (addLabel) {
      addLabel.textContent = available
        ? 'ADD TO CART - ' + formatPdpMoney(unitPriceAmount * quantity, fallbackPrice)
        : 'SOLD OUT';
    }
  }

  /* 상품 옵션별 dropdown — 선택값 조합을 Shopify variant id와 동기화 */
  function initVariantPicker(picker) {
    if (!picker || picker.getAttribute('data-kuoca-pdp-variant-picker-ready') === 'true') return;

    var selects = Array.prototype.slice.call(picker.querySelectorAll('[data-kuoca-pdp-select]'));
    var input = picker.querySelector('[data-kuoca-pdp-variant-input]');
    var variants = Array.prototype.slice.call(picker.querySelectorAll('[data-kuoca-pdp-variant]')).map(function (node) {
      var variantOptions;
      try {
        variantOptions = JSON.parse(node.getAttribute('data-variant-options'));
      } catch (error) {
        variantOptions = [];
      }
      return {
        id: node.getAttribute('data-variant-id'),
        options: variantOptions,
        available: node.getAttribute('data-variant-available') === 'true',
        price: node.getAttribute('data-variant-price'),
        priceAmount: node.getAttribute('data-variant-price-amount'),
        comparePrice: node.getAttribute('data-variant-compare-price'),
        comparePriceAmount: node.getAttribute('data-variant-compare-price-amount'),
        onSale: node.getAttribute('data-variant-on-sale') === 'true',
        mediaId: node.getAttribute('data-variant-media-id') || '',
      };
    });
    if (!selects.length || !input || !variants.length) return;

    picker.setAttribute('data-kuoca-pdp-variant-picker-ready', 'true');

    function selectedValues() {
      return selects.map(function (select) {
        return select.getAttribute('data-kuoca-pdp-selected-value');
      });
    }

    function findSelectedVariant() {
      var values = selectedValues();
      return variants.find(function (variant) {
        return (
          variant.options.length === values.length &&
          variant.options.every(function (option, index) {
            return option === values[index];
          })
        );
      });
    }

    function updateVariant() {
      var variant = findSelectedVariant();
      var detail = picker.closest('.kuoca-pdp-detail');
      var priceBlock = detail && detail.querySelector('[data-kuoca-pdp-price]');
      var comparePrice = priceBlock && priceBlock.querySelector('[data-kuoca-pdp-compare-price]');
      var form = picker.closest('form');
      var addButton = form && form.querySelector('.kuoca-pdp-addcart');
      var addLabel = addButton && addButton.querySelector('[data-kuoca-pdp-addcart-label]');

      if (!variant) {
        input.value = '';
        input.disabled = true;
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'UNAVAILABLE';
        if (comparePrice) {
          comparePrice.textContent = '';
          comparePrice.hidden = true;
        }
        return;
      }

      input.disabled = false;
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (priceBlock) {
        priceBlock.setAttribute('data-kuoca-pdp-unit-price-amount', variant.priceAmount);
        priceBlock.setAttribute('data-kuoca-pdp-unit-compare-price-amount', variant.comparePriceAmount);
        priceBlock.setAttribute('data-kuoca-pdp-on-sale', String(variant.onSale));
        priceBlock.setAttribute('data-kuoca-pdp-variant-available', String(variant.available));
      }
      updateProductPricing(detail);
      showMedia(variant.mediaId);
    }

    selects.forEach(function (select) {
      var trigger = select.querySelector('.kuoca-pdp-dropdown');
      var sheet = select.querySelector('.kuoca-pdp-dropdown__sheet');
      var value = select.querySelector('[data-kuoca-pdp-select-value]');
      var optionIndex = parseInt(select.getAttribute('data-kuoca-pdp-option-index'), 10);
      var options = Array.prototype.slice.call(select.querySelectorAll('[data-kuoca-pdp-option-value]'));
      if (!trigger || !sheet || !value || Number.isNaN(optionIndex) || !options.length) return;

      options.forEach(function (option) {
        var optionValue = option.getAttribute('data-kuoca-pdp-option-value');
        var hasAvailableVariant = variants.some(function (variant) {
          return variant.available && variant.options[optionIndex] === optionValue;
        });
        /*
          품절 옵션도 선택은 된다 — 막아두면 그 이형 상품의 가격·상세를 아예 볼 수
          없다(2026-09-01 QA). 흐린 색으로 재고 없음만 알리고, 선택하면 가격 취소선 +
          SOLD OUT + 담기 비활성으로 상태를 알린다.
        */
        option.disabled = false;
        option.removeAttribute('aria-disabled');
        option.setAttribute('data-kuoca-pdp-option-soldout', String(!hasAvailableVariant));
      });

      function enabledOptions() {
        return options.filter(function (option) {
          return !option.disabled;
        });
      }

      function setOpen(open, focusOption) {
        if (open) {
          selects.forEach(function (otherSelect) {
            if (otherSelect === select) return;
            otherSelect.classList.remove('is-open');
            var otherTrigger = otherSelect.querySelector('.kuoca-pdp-dropdown');
            var otherSheet = otherSelect.querySelector('.kuoca-pdp-dropdown__sheet');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherSheet) otherSheet.hidden = true;
          });
        }

        select.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        sheet.hidden = !open;

        if (open && focusOption) {
          window.setTimeout(function () {
            var selected = sheet.querySelector('[aria-selected="true"]:not(:disabled)');
            var first = enabledOptions()[0];
            (selected || first || trigger).focus();
          }, 0);
        }
      }

      function selectOption(option) {
        if (!option || option.disabled) return;

        var optionValue = option.getAttribute('data-kuoca-pdp-option-value');
        select.setAttribute('data-kuoca-pdp-selected-value', optionValue);
        options.forEach(function (item) {
          item.setAttribute('aria-selected', String(item === option));
        });
        value.textContent = optionValue;
        updateVariant();
        setOpen(false, false);
        trigger.focus();
      }

      trigger.addEventListener('click', function () {
        setOpen(!select.classList.contains('is-open'), true);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          setOpen(true, true);
        }
      });

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          selectOption(option);
        });
      });

      sheet.addEventListener('keydown', function (event) {
        var available = enabledOptions();
        var current = available.indexOf(document.activeElement);
        var next = current;

        if (event.key === 'ArrowDown') next = Math.min(current + 1, available.length - 1);
        else if (event.key === 'ArrowUp') next = Math.max(current - 1, 0);
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = available.length - 1;
        else if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false, false);
          trigger.focus();
          return;
        } else return;

        event.preventDefault();
        if (available[next]) available[next].focus();
      });

      document.addEventListener('click', function (event) {
        if (!select.contains(event.target)) setOpen(false, false);
      });
    });

    updateVariant();
  }

  document.querySelectorAll('[data-kuoca-pdp-variant-picker]').forEach(initVariantPicker);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-kuoca-pdp-variant-picker]').forEach(initVariantPicker);
  });

  /* 수량 스테퍼 — 표시값 + 폼 hidden quantity 동기화 */
  var qtyValue = document.getElementById('kuocaQtyValue');
  var qtyInput = document.getElementById('kuocaQtyInput');
  function setQty(v) {
    v = Math.max(1, v);
    if (qtyValue) qtyValue.textContent = v;
    if (qtyInput) {
      qtyInput.value = v;
      updateProductPricing(qtyInput.closest('.kuoca-pdp-detail'));
    }
  }
  var minus = document.getElementById('kuocaQtyMinus');
  var plus = document.getElementById('kuocaQtyPlus');
  if (minus)
    minus.addEventListener('click', function () {
      setQty(parseInt(qtyValue.textContent, 10) - 1);
    });
  if (plus)
    plus.addEventListener('click', function () {
      setQty(parseInt(qtyValue.textContent, 10) + 1);
    });
  document.querySelectorAll('.kuoca-pdp-detail').forEach(updateProductPricing);

  /* 아코디언 — 단일 열림 + 실제 콘텐츠 높이 */
  function closeAccordionItem(item) {
    var head = item.querySelector('.kuoca-pdp-acc__head');
    var panel = item.querySelector('.kuoca-pdp-acc__panel');
    item.classList.remove('is-open');
    if (head) head.setAttribute('aria-expanded', 'false');
    if (panel) panel.style.maxHeight = '0px';
  }

  function openAccordionItem(item) {
    var head = item.querySelector('.kuoca-pdp-acc__head');
    var panel = item.querySelector('.kuoca-pdp-acc__panel');
    item.classList.add('is-open');
    if (head) head.setAttribute('aria-expanded', 'true');
    if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  function initProductAccordions(root) {
    root.querySelectorAll('.kuoca-pdp-accordion').forEach(function (group) {
      group.querySelectorAll('.kuoca-pdp-acc__head').forEach(function (head) {
        if (head.getAttribute('data-kuoca-accordion-ready') === 'true') return;
        head.setAttribute('data-kuoca-accordion-ready', 'true');
        head.addEventListener('click', function () {
          var item = head.closest('.kuoca-pdp-acc');
          var shouldOpen = !item.classList.contains('is-open');

          group.querySelectorAll('.kuoca-pdp-acc').forEach(function (otherItem) {
            closeAccordionItem(otherItem);
          });
          if (shouldOpen) openAccordionItem(item);
        });
      });
    });
  }

  initProductAccordions(document);
  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordions(event.target);
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.kuoca-pdp-acc.is-open').forEach(function (item) {
      var panel = item.querySelector('.kuoca-pdp-acc__panel');
      if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  });

  /* YMAL: Shopify product recommendations 비동기 로드 (실상품일 때만 — data-kuoca-recs-url).
     섹션은 hidden + 빈 그리드로 시작한다(2026-08-04 qa: 목업 선렌더 → 실추천 교체 시
     더미 깜빡임). 실추천이 있을 때만 채우고 노출, 없거나 실패면 섹션 제거. */
  var recs = document.querySelector('[data-kuoca-recs-url]');
  if (recs) {
    fetch(recs.getAttribute('data-kuoca-recs-url'))
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-kuoca-recs-grid]');
        var target = document.querySelector('[data-kuoca-recs-grid]');
        if (fresh && target && fresh.children.length > 0) {
          target.innerHTML = fresh.innerHTML;
          recs.removeAttribute('hidden');
        } else {
          recs.remove(); /* 추천 0건 — 빈 섹션(타이틀만) 노출 방지 */
        }
      })
      .catch(function () {
        recs.remove(); /* 요청 실패 — hidden 빈 섹션 잔존 방지 */
      });
  }
})();
